import { render, staticRenderFns } from "./RevisionInfertile.vue?vue&type=template&id=89805f3c"
import script from "./RevisionInfertile.vue?vue&type=script&lang=js"
export * from "./RevisionInfertile.vue?vue&type=script&lang=js"
import style0 from "./RevisionInfertile.vue?vue&type=style&index=0&id=89805f3c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports